import { ApiResponseStatusEnum } from "@/model/communication/ApiResponseStatusEnum";
import { SET_CURRENCIES, SET_INSTALLATIONS_LIST, SET_INSTALLATIONS_LIST_FETCHING, SET_LIST_TOTAL_LENGTH } from "./mutations";

import { FetchInstallationsWorkloadCommand } from "@/model/communication/workload/FetchInstallationsWorkloadCommand";
import { GetCurrenciesInWorkloadDbTableCommand } from "@/model/communication/workload/GetCurrenciesInWorkloadDbTableCommand";
import { GetWorkloadResData } from "@/model/communication/workload/GetWorkloadResData";
import { GET_AVAILABLE_BRANCHES } from "../ApplicationModule/actions";

export const ON_PAGE_LOAD = "ON_PAGE_LOAD";
export const FETCH_INSTALLATIONS_WORKLOAD = "FETCH_INSTALLATIONS_WORKLOAD";
export const GET_WORKLOAD_CURRENCIES = "GET_WORKLOAD_CURRENCIES";

export default {
    async [ON_PAGE_LOAD]({ dispatch }) {
        dispatch(GET_AVAILABLE_BRANCHES);
        // commit(SET_INSTALLATIONS_LIST, []);
        // commit(SET_LIST_TOTAL_LENGTH, 0);
    },

    async [FETCH_INSTALLATIONS_WORKLOAD]({ commit, state }) {
        commit(SET_INSTALLATIONS_LIST_FETCHING, true);
        var res: GetWorkloadResData = await new FetchInstallationsWorkloadCommand(state.reqData).execute();

        if (res.responseStatus == ApiResponseStatusEnum.Success) {
            commit(SET_INSTALLATIONS_LIST, res.installationsList);
            commit(SET_LIST_TOTAL_LENGTH, res.paginatedTotalItems);
        }

        commit(SET_INSTALLATIONS_LIST_FETCHING, false);
    },

    async [GET_WORKLOAD_CURRENCIES]({ commit }) {
        var res: string[] = await new GetCurrenciesInWorkloadDbTableCommand().execute();
        if (res.length > 0) commit(SET_CURRENCIES, res);
    },
};
